// assets/js/homepage.js
(function () {
  // ===== Tweakables =====
  const BUTTON_ROW_OFFSET = 120;      // buttons row: px below the wheel's vertical center
  const PREVIEW_FADE = true;         // fade preview in/out via .is-visible class
  const PREVIEW_OFFSET_PX = 32;  

  // Wave motion
  const WAVE_ENABLED = true;
  const WAVE_AMP_PX = 10;            // amplitude in pixels (pre-snap)
  const WAVE_SPEED = 0.002;          // radians per ms
  const WAVE_PHASE_STEP = 0.8;       // per-button phase offset
  const WAVE_SNAP_PX = 4;            // <— snap vertical motion to multiples of this (e.g., 4px)

  // --- Mobile stack (vertical list, horizontal wave) ---
  const MOBILE_BUTTON_OFFSET = 112;     // px below wheel center
  const MOBILE_WAVE_X_ENABLED = true;
  const MOBILE_WAVE_X_AMP = 96;        // amplitude (px) before snapping
  const MOBILE_WAVE_X_SPEED = 0.001;   // radians per ms
  const MOBILE_WAVE_X_PHASE = 1.2;    // offset per item
  const MOBILE_WAVE_X_SNAP = 2;        // move in 4px steps for pixel-perfect feel
  const MQ_MOBILE = '(max-width: 1030px)';

  // ===== Shorthand =====
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const snap = (val, step=WAVE_SNAP_PX) => Math.round(val / step) * step;

  let rafId = null;

  function placeButtonsRow() {
    const row   = $('#homeButtons');
    const wheel = $('#dalichromeWheel');
    if (!row || !wheel) return;

    const parent     = row.offsetParent || document.body;
    const wheelRect  = wheel.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const wheelCenterY = wheelRect.top + wheelRect.height / 2;
    const topPx = Math.round((wheelCenterY - parentRect.top) + BUTTON_ROW_OFFSET);
    row.style.top = topPx + 'px';
    row.style.visibility = 'visible';
  }

function placePreviewVertically() {
  const row    = document.getElementById('homeButtons');
  const wheel  = document.getElementById('dalichromeWheel');
  const prevEl = document.getElementById('preview');
  if (!row || !wheel || !prevEl) return;

  const parent     = prevEl.offsetParent || row.offsetParent || document.body;
  const parentRect = parent.getBoundingClientRect();
  const wheelRect  = wheel.getBoundingClientRect();
  const rowRect    = row.getBoundingClientRect();

  const wheelCenterY = wheelRect.top + wheelRect.height / 2;

  // midpoint between wheel center and row top, then shift by PREVIEW_OFFSET_PX
  const midY = Math.round(((wheelCenterY + rowRect.top) / 2) - parentRect.top + PREVIEW_OFFSET_PX);

  prevEl.style.top = midY + 'px';
}

  function preloadPreviews() {
    // Preload all preview images to avoid first-hover flicker
    $$('.home-button-link').forEach(a => {
      const src = a.getAttribute('data-preview');
      if (src) {
        const img = new Image();
        img.src = src;
      }
    });
  }

  function setupPreviewSwap() {
    const row    = $('#homeButtons');
    const prevEl = $('#preview');
    if (!row || !prevEl) return;

    // When the preview image loads (different intrinsic size), re-place vertically
    prevEl.addEventListener('load', placePreviewVertically);

    function show(a) {
      const src = a.getAttribute('data-preview');
      if (!src) return;
      if (prevEl.src !== src) {
        prevEl.src = src;
        // Also re-place immediately for snappy feel (load event will finalize)
        placePreviewVertically();
      }
      if (PREVIEW_FADE) prevEl.classList.add('is-visible');
    }

    function hide() {
      if (PREVIEW_FADE) prevEl.classList.remove('is-visible');
    }

    // Delegate hovering/focus to the row
    row.addEventListener('mouseenter', (e) => {
      const a = e.target.closest('.home-button-link');
      if (a) show(a);
    }, true);

    row.addEventListener('mouseleave', hide);
    row.addEventListener('focusin', (e) => {
      const a = e.target.closest('.home-button-link');
      if (a) show(a);
    });
    row.addEventListener('focusout', hide);
  }

  function startWave() {
    if (!WAVE_ENABLED) return;
    const items = $$('.home-button');
    if (!items.length) return;

    const t0 = performance.now();
    function tick(now) {
      const t = now - t0;
      for (let i = 0; i < items.length; i++) {
        const y = Math.sin(t * WAVE_SPEED + i * WAVE_PHASE_STEP) * WAVE_AMP_PX;
        const ySnapped = snap(y, WAVE_SNAP_PX); // <— snap motion to pixel step
        items[i].style.setProperty('--wave-y', `${ySnapped}px`);
      }
      rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);
  }

  function stopWave() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
  }

  function onResize() {
    placeButtonsRow();
    placePreviewVertically();
  }

  function init() {
  const wheel = document.getElementById('dalichromeWheel');
  if (!wheel) return;

  function applyMode() {
    if (mqlMobile.matches) {
      // MOBILE: position vertical stack + start horizontal wave
      placeButtonsMobile();
      stopWave();           // stop desktop vertical wave if it was running
      startWaveMobileX();
    } else {
      // DESKTOP: position desktop row + start vertical wave (your existing logic)
      placeButtonsRow();
      stopWaveMobileX();    // stop mobile wave if it was running
      startWave();
    }
  }

  const run = () => {
    // your existing: placeButtonsRow(), placePreviewVertically(), preloadPreviews(), setupPreviewSwap()
    // keep them, but the mode switch below will start the correct wave
    placeButtonsRow();
    placePreviewVertically();
    preloadPreviews();
    setupPreviewSwap();
    applyMode();
  };

  if (wheel.complete) run();
  else wheel.addEventListener('load', run, { once: true });

  // On viewport changes
  window.addEventListener('resize', () => {
    if (mqlMobile.matches) placeButtonsMobile();
    else placeButtonsRow();
    placePreviewVertically();
  });

  // Switch waves when crossing the breakpoint
  mqlMobile.addEventListener('change', applyMode);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopWave();
      stopWaveMobileX();
    } else {
      applyMode();
    }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  const mqlMobile = window.matchMedia(MQ_MOBILE);
  let rafIdMobileX = null;

  function placeButtonsMobile() {
    const stack = document.getElementById('homeButtonsMobile');
    const wheel = document.getElementById('dalichromeWheel');
    if (!stack || !wheel) return;

    const parent     = stack.offsetParent || document.body;
    const wheelRect  = wheel.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();

    const centerY = wheelRect.top + wheelRect.height / 2;
    const topPx   = Math.round((centerY - parentRect.top) + MOBILE_BUTTON_OFFSET);
    stack.style.top = topPx + 'px';
    stack.style.visibility = 'visible';
  }

  function startWaveMobileX() {
    if (!MOBILE_WAVE_X_ENABLED) return;
    const items = Array.from(document.querySelectorAll('.home-button-mobile'));
    if (!items.length) return;

    const t0 = performance.now();
    const snap = (v, step = MOBILE_WAVE_X_SNAP) => Math.round(v / step) * step;

    function tick(now) {
      const t = now - t0;
      // Half amplitude at the x1 tier (<500px) so buttons sway proportionally less
      const amp = window.innerWidth < 500 ? MOBILE_WAVE_X_AMP / 2 : MOBILE_WAVE_X_AMP;
      for (let i = 0; i < items.length; i++) {
        const x = Math.sin(t * MOBILE_WAVE_X_SPEED + i * MOBILE_WAVE_X_PHASE) * amp;
        items[i].style.setProperty('--wave-x', `${snap(x)}px`);
      }
      rafIdMobileX = requestAnimationFrame(tick);
    }
    rafIdMobileX = requestAnimationFrame(tick);
  }

  function stopWaveMobileX() {
    if (rafIdMobileX) cancelAnimationFrame(rafIdMobileX);
    rafIdMobileX = null;
  }
})();
